export const apiImport = "/1.0/crm/contact/import"
export const apiAssigned = '/1.0/crm/contact/assigned'
export const apiFastAssigned = '/1.0/crm/contact/fastAssigned'
export const apiListPersonnel = '/1.0/crm/contact/listPersonnel'
export const apiExportOrder = '/1.0/crm/order/export'
export const apiTotalPrice = '/1.0/crm/order/totalPrice'
export const apiOrderUpdateStatus = '/1.0/crm/order/updateStatus'
export const apiCallLog = '/1.0/crm/contact/callLog'
export const apiGetProvince = '/1.0/crm/province'
export const apiGetDistrict = '/1.0/crm/district'
export const apiGetWard = '/1.0/crm/ward'
export const apiGetStatistics = '/1.0/crm/dashboard/index'
export const apiGetGrowthStatistics = '/1.0/crm/dashboard/growthStatistics'
export const apiGetRolePermissions = id => `/1.0/crm/permission/${id}/index`
export const apiGetAllPermission = `/1.0/crm/permission/all`
export const apiUpdateStatusOrderVTP = `/1.0/crm/viettel/update`
export const apiUpdateStatusOrderCOD = id => `1.0/crm/order/${id}/updateCod`
export const apiGetOrderActivities = id => `1.0/crm/order/${id}/activities`
export const apiRequestRefund = id => `1.0/crm/order/${id}/requestRefund`
export const apiAssignPermissions = id => `/1.0/crm/permission/${id}/assignPermissions`
export const apiSalary = '/1.0/personnel/salary/list'
export const apiGetTopSales = '/1.0/crm/dashboard/topSalesChart'
export const apiCreateSalaryConfig = '/1.0/personnel/salary-setting/create'
export const apiUpdateSalaryConfig = id => `/1.0/personnel/salary-setting/${id}/update`
export const apiGetSalaryConfig = '/1.0/personnel/salary-setting/show'
export const apiGetListSalaryConfig = '/1.0/personnel/salary-setting/list'
export const apiGetDetailSalaryConfig = id => `/1.0/personnel/salary-setting/${id}/detail`
export const apiCreateSalaryConfigV2 = '/1.0/personnel/salary-setting-v2/create'
export const apiUpdateSalaryConfigV2 = id => `/1.0/personnel/salary-setting-v2/${id}/update`
export const apiGetListSalaryConfigV2 = '/1.0/personnel/salary-setting-v2/list'
export const apiGetDetailSalaryConfigV2 = id => `/1.0/personnel/salary-setting-v2/${id}/detail`
export const apiDeleteSalaryConfigV2 = id => `/1.0/personnel/salary-setting-v2/${id}/delete`
export const apiGetAssignedDepartmentsV2 = '/1.0/personnel/salary-setting-v2/assigned-departments'
export const apiMonthlySalaryV2List = '/1.0/personnel/monthly-salary-v2/list'
export const apiMonthlySalaryV2Detail = id => `/1.0/personnel/monthly-salary-v2/${id}/detail`
export const apiMonthlySalaryV2Calculate = '/1.0/personnel/monthly-salary-v2/calculate'
export const apiMonthlySalaryV2UpdateResponsibility = id => `/1.0/personnel/monthly-salary-v2/${id}/update-responsibility`
export const apiMonthlySalaryV2Adjust = id => `/1.0/personnel/monthly-salary-v2/${id}/adjust`
export const apiMonthlySalaryV2Revert = id => `/1.0/personnel/monthly-salary-v2/${id}/revert`
export const apiMonthlySalaryV2ToggleClose = '/1.0/personnel/monthly-salary-v2/toggle-close'
export const apiMonthlySalaryV2Export = '/1.0/personnel/monthly-salary-v2/export'
export const apiMonthlySalaryV2ExportVcb = '/1.0/personnel/monthly-salary-v2/export-vcb'
export const apiMonthlySalaryV2SendEmail = id => `/1.0/personnel/monthly-salary-v2/${id}/send-email`
export const apiMonthlySalaryV2SendAllEmails = '/1.0/personnel/monthly-salary-v2/send-all-emails'
export const apiGetDashBoardHome = '/1.0/crm/dashboard/home'
export const apiGetDashBoardHomeSummary = '/1.0/crm/dashboard/home/summary'
export const apiGetDashBoardHomeStatusCounts = '/1.0/crm/dashboard/home/status-counts'
export const apiGetDashBoardHomeCharts = '/1.0/crm/dashboard/home/charts'
export const apiGetDashBoardHomeGrowth = '/1.0/crm/dashboard/home/growth'
export const apiGetDashBoardHomeDepartmentMonthly = '/1.0/crm/dashboard/home/department-monthly'
export const apiGetIdCallerInfo = '/1.0/crm/search'
export const apiGetOrdersProcessed = '/1.0/crm/getOrdersProcessed'
export const apiSearchOrderVTP = '/1.0/crm/order/search'
export const apiGetCars = '/1.0/crm/order/carlist'
export const apiGetTotalPriceOrder = '/1.0/crm/contact/totalPriceContact'
export const apiGetListWeeklyBonus = '/1.0/crm/bonuses/list'
export const apiWeeklyBonusList = '/1.0/crm/weekly-bonuses/list'
export const apiWeeklyBonusSync = '/1.0/crm/weekly-bonuses/sync'
export const apiWeeklyBonusExport = '/1.0/crm/weekly-bonuses/export'
export const apiGetListCall = '/1.0/crm/call/zenifyHistory'
export const apiGetListCallIty = '/1.0/crm/ity/list'
export const apiSearchInfoPhone = '/1.0/crm/search'
export const apiRestoreContact = '/1.0/crm/contact/restore'
export const apiStatistics = '/1.0/crm/order/statisticsMonthlySale'
export const apiMergePDF = '/1.0/crm/order/vni/mergePDF'
export const apiCheckStatusDBV = '/1.0/crm/order/vni/status'
export const apiCheckStatusVTP = '/1.0/crm/viettel/check/status'
export const apiPrintPDFVTP = '/1.0/crm/viettel/printViettel'
export const apiCreateVTP = '/1.0/crm/viettel/createViettelPost'
export const apiUpdateOrderDesc = id => `/1.0/crm/order/${id}/update/desc`
export const apiUpdateOrderNoteSale = id => `/1.0/crm/order/${id}/update/note`
export const apiBrowsePayment = id => `/1.0/crm/order/${id}/browsePayment`
export const apiCreatePVI = '/1.0/crm/pvi/create'
export const apiGetPviPolicyNumber = '/1.0/crm/pvi/get/policy/number'
export const apiGetListDiscountPrice = '/1.0/crm/discount/setting/list'
export const apiCreateDiscountPrice = '/1.0/crm/discount/setting/create'
export const apiGetDetailDiscountPrice = id => `/1.0/crm/discount/setting/${id}/detail`
export const apiUpdateDiscountPrice = id => `/1.0/crm/discount/setting/${id}/update`
export const apiUpdateOrderNotYetPaid = id => `/1.0/crm/order/${id}/notYetPaid`
export const apiGetBrandCar = '/1.0/client/pvi/brandcar'
export const apiUpdateReturn = id => `/1.0/crm/order/${id}/updateReturn`
export const apiGetCategoryMoto = '/1.0/client/pvi/category/moto'
export const apiExportListOrder = '/1.0/crm/order/exportList'
export const apiCreateLpbi = "1.0/crm/lpbi/create"
export const apiUpdateStatusOrder = id => `/1.0/crm/order/${id}/updateStatusOrder`
export const apiDetailDepartmentOrder = id =>`/1.0/crm/order/${id}/detailDepartmentMonthlyStatistic`